import { Permission } from "~/models/dto";

import { createNewServiceTokenFn, createSubjectFn, grantPermissionsFn } from "../common/openapi";

import type { UseMutationOptions } from "./react-query";

export interface CreateServiceTokenParams {
	cluster?: string;
	name: string;
}

export const createServiceToken = {
	mutationKey: ["servicetoken", "create"],
	mutationFn: async ({ cluster, name }) => {
		/**
		 * Create a subject and a service token for it.
		 * The subject has the permissions
		 * - UpdateMetrics: to send (metric) data to the receiver and/or the otel collector
		 * - (optionally) UpdateScopedPermissions: to send rbac data for a cluster
		 */
		await createSubjectFn({
			subject: name,
			body: {},
		});
		if (cluster) {
			await grantPermissionsFn({
				subject: name,
				body: {
					permission: Permission.UpdateScopedPermissions,
					resourceName: cluster,
				},
			});
		}
		await grantPermissionsFn({
			subject: name,
			body: {
				permission: Permission.UpdateMetrics,
				resourceName: "system",
			},
		});
		const createdToken = await createNewServiceTokenFn({
			body: {
				name,
				roles: [],
				dedicatedSubject: name,
			},
		});
		return createdToken.token;
	},
} satisfies UseMutationOptions<string, Error, CreateServiceTokenParams>;
